import React, { useState, useEffect } from "react";
import { map, distinctUntilChanged } from "rxjs/operators";

function CompStatesView(props) {
  return (
    <div className="CompState">
      {props.states.valueSeq().map(state => {
        return <span key={state.get("id")}>{state.get("name")}</span>;
      })}
    </div>
  );
}
export default CompStatesView;



// WEBPACK FOOTER //
// ./src/components/CompStatesView.js